import { state as validationState } from '@/store/modules/validation/state';

const questionnaireRoutes = [
  {
    path: '/perguntas',
    name: 'questions',
    component: () => import('@/views/questions/Questions.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: !validationState.data.urlToken,
        title: 'Perguntas clínicas',
      },
    },
  },
  {
    path: '/ultimas-perguntas',
    name: 'questions-conclusion',
    component: () => import('@/views/questions/QuestionsConclusion.view.vue'),
    meta: {
      header: {
        title: 'Perguntas clínicas',
      },
    },
  },
  {
    path: '/questionario',
    name: 'questionnaire',
    component: () => import('@/views/questionnaries/Questionnaries.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
      },
    },
  },
];

export default questionnaireRoutes;
